var exports = {
  "k": "x2b2fbebb--93541a--container",
};

module.exports = exports;
